import { signInCreateNewAccountStyles } from "@insite/content-library/Widgets/SignIn/SignInCreateNewAccount";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import { css } from "styled-components";

signInCreateNewAccountStyles.createNewAccountButton = {
    variant: "primary",
    css: css`
        border-radius: 25px;
        border: 1px solid ${getColor("warning")};
        background-color: ${getColor("warning")};
        > span {
            color: ${getColor("info.contrast")} !important;
            font-family: ${TYPOGRAPHY.fontFamily.dosis};
        }
        &:hover {
            border: 1px solid ${getColor("warning.contrast")};
            background-color: ${getColor("warning.contrast")};
        }
    `,
};
